"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  dimension8: 'setBookingID',
  dimension9: 'setUserID',
  dimension10: 'setListingID',
  dimension12: 'setCity',
  dimension13: 'setMoveIn',
  dimension14: 'setMoveOut',
  dimension15: 'setMinPrice',
  dimension16: 'setMaxPrice',
  dimension17: 'setSortBy',
  dimension18: 'setPropertyType',
  dimension19: 'setInstantBooking',
  dimension20: 'setChecked',
  dimension21: 'setCurrentPage',
  dimension22: 'setTotalPages',
  dimension23: 'setMapLimits',
  dimension24: 'setListingSection'
};
exports.default = _default;
//# sourceMappingURL=dimensionConfig.js.map